import React from 'react'
import { Input, FormField, Label, getPaletteColor } from 'pcln-design-system'
import { ChevronDown as ChevronDownIcon, Search as SearchIcon, Warning as WarningIcon } from 'pcln-icons'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const TypeAheadLabel = styled(Label)`
  width: auto;
  font-size: ${({ labelFontSize }) => labelFontSize};
`

const DisableableFormField = styled(FormField)`
  & input:disabled {
    background-color: ${getPaletteColor('background.light')};
    color: ${getPaletteColor('text.light')};
    cursor: not-allowed;
  }

  & svg {
    ${(props) => (props.disabled ? `color: ${getPaletteColor('text.light')};` : '')}
    z-index: 1;
  }
`

class TypeAheadInput extends React.Component {
  render() {
    const {
      autoFocus,
      autoHide,
      color,
      disabled,
      hasError,
      hideIcon,
      icon,
      id,
      isSelector,
      label,
      passedThroughProps,
      labelFontSize,
      ...props
    } = this.props

    return (
      <DisableableFormField {...passedThroughProps} disabled={disabled}>
        {label && (
          <TypeAheadLabel autoHide={autoHide} labelFontSize={labelFontSize}>
            {label}
          </TypeAheadLabel>
        )}
        {!hideIcon && (icon || <SearchIcon color='primary' size={24} />)}
        <Input
          id={id}
          autoComplete='off'
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          color={color}
          disabled={disabled}
          ref={(elem) => {
            this.inputRef = elem
          }}
          {...props}
        />
        {Boolean(hasError) && <WarningIcon color='warning' size={24} />}
        {isSelector && <ChevronDownIcon data-testid='selector-dropdown-icon' color='primary' size={24} />}
      </DisableableFormField>
    )
  }
}

TypeAheadInput.propTypes = {
  autoFocus: PropTypes.bool,
  autoHide: PropTypes.bool,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hideIcon: PropTypes.bool,
  icon: PropTypes.node,
  id: PropTypes.string,
  isSelector: PropTypes.bool,
  label: PropTypes.string,
  labelFontSize: PropTypes.string,
  passedThroughProps: PropTypes.shape({
    style: PropTypes.object,
  }),
  onChange: PropTypes.func.isRequired,
}

TypeAheadInput.defaultProps = {
  passedThroughProps: null,
  hideIcon: false,
  isSelector: false,
  labelFontSize: '10px',
}

export default TypeAheadInput
